
const API_URL = 

window.location.hostname === "localhost"
    ? "http://localhost:8081"
    : "https://oret.africa/tree/backend";

//https://oret.africa/tree/oretapp/backend
//https://testapp.oret.africa

export default API_URL;
